import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation Mutation($id: Int!) {
    deleteModality(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteModality: {
    id?: number;
  };
}
